import axios from 'axios'

import { clearLocalStorage } from '../utils/auth'

const refreshToken = localStorage.getItem('refreshToken')

const onGetAccessTokenFail = () => {
    clearLocalStorage()
}

const getAccessToken = async () => {
    return await axios
        .get(`${process.env.BACKEND_URL}/refresh`, {
            headers: {
                Authorization: `Bearer ${refreshToken}`,
            },
        })
        .then((response) => {
            const newAccessToken = response.data.access_token
            localStorage.setItem('accessToken', newAccessToken)
            return newAccessToken as string
        })
        .catch(() => {
            onGetAccessTokenFail()
        })
}

export default getAccessToken
